import { useNavigate, useParams } from "react-router-dom";
import { RedirectIfLoggedIn } from "../../../components/RedirectIfLoggedIn";
import { useSelector } from "react-redux";
import { AppState } from "../../../store/configureStore";
import { useEffect, useState } from "react";
import { appStageToTitle } from "../../../helpers/appStageHelper";
import { Button, Input } from "semantic-ui-react";
import { resetPassword } from "../../../services/authenticationService";
import { toast } from "../../..";
import logo from "../tscnet-logo.png";
import "../../../App.css";
import "../Login.css";
import "./AdditionalLoginComponents.css";

export const ResetPassword = () => {
    const navigate = useNavigate();
    const { token } = useParams();
    const [title, setTitle] = useState("");
    const stageState = useSelector((state: AppState) => state.appStage);
    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        try {
            const title = appStageToTitle(stageState.stage);
            setTitle(title);
            document.title = title;
        } catch (err) {
            toast("Unable to determine environment", false, 3000);
        }
    }, [stageState.stage]);

    const handleResetPassword = async () => {
        if (token === undefined) return;

        setSending(true);
        try {
            await resetPassword({
                password: password,
                token: token,
            });
            toast("Password has been reset.", true, 3000);
            setSuccess(true);
            setRepeatPassword("");
            setPassword("");
        } catch (err) {
            toast(err instanceof Error ? err.message : "Unable to reset password.", false, 3000);
        }
        setSending(false);
    };

    return (
        <div className="container-center">
            <RedirectIfLoggedIn />
            <div id="login-form-container">
                <img id="logo" src={logo} alt="Logo" />
                <h1 id="h1-login-a" className="tsc-blue">
                    {title}
                </h1>

                <div className="additional-login-component-container">
                    <h2>Reset password</h2>

                    <div className="input-container">
                        <Input
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            type="password"
                            placeholder="New password"
                        />
                        <Input
                            value={repeatPassword}
                            onChange={e => setRepeatPassword(e.target.value)}
                            type="password"
                            placeholder="Repeat new password"
                        />

                        <Button primary loading={sending} onClick={handleResetPassword}>
                            Reset password
                        </Button>
                        {success && (
                            <Button
                                primary
                                onClick={() => navigate("/login/local")}
                                className="no-margin-button"
                            >
                                Back to login
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
